import { createStore } from 'stimulus-store';

export const regionStore = createStore({
    name: 'regionStore',
    type: Object,
    initialValue: {}
});